import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionMatch } from './competition-match'
import { CompetitionMatchSerializer } from './competition-match.serializer'

@Injectable()
export class CompetitionMatchService extends ResourceService<CompetitionMatch> {
  constructor(
    private http: HttpClient,
    private competitionMatchSerializer: CompetitionMatchSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-matches`,
      competitionMatchSerializer
    )
  }
}
